import React from 'react'
import Footer from '../Common/Footer';
import SubNav from "../Common/SubNav";
import MessageTempModify from '../Pages/MessageTempModify';

const MessageTemplate = (props) => {
    const { isShow, setIsShow } = props;
    return (
        <>
            <div className='h-screen w-full overflow-auto responsive_small'>
                <SubNav isShow={isShow} setIsShow={setIsShow} />
                <div className='h-full w-full'>
                    <div className='items-center justify-center w-full h-screen overflow-auto p-4 bg-slate-100 '>
                        <h1 className='items bg-center py-3 text-2xl sm:text-2xl'>Message Template</h1>
                        <div className='mb-3 border-t-sky-500 border-t-4 bg-white w-full items-center justify-center'>
                            <MessageTempModify isShow={isShow} setIsShow={setIsShow} />
                        </div>
                    </div>
                    <Footer/>
                </div>
            </div>
        </>
    )
}

export default MessageTemplate